import React from 'react';
import { Video } from '../../types';
import * as Icons from 'react-icons/fi';

// Styled Components
import {
    Section,
    SectionHeader,
    SectionTitle,
    AddButton,
    LoadingState,
    SpinningLoader,
    ErrorState
} from '../../styles/AdminLayout.styles';

import {
    FiltersBar,
    FilterSelect,
    DataTable,
    TableHeader,
    TableRow,
    TableCell,
    ActionButtons,
    ActionBtn
} from '../../styles/AdminTable.styles';

interface AdminVideosProps {
    videos: Video[];
    loading: boolean;
    error: string | null;
    searchQuery: string;
    levelFilter: string;
    onSearchChange: (query: string) => void;
    onLevelFilterChange: (level: string) => void;
    onCreateVideo: () => void;
    onEditVideo: (video: Video) => void;
    onDeleteVideo: (videoId: number) => void;
}

const AdminVideos: React.FC<AdminVideosProps> = ({
    videos,
    loading,
    error,
    searchQuery,
    levelFilter,
    onSearchChange,
    onLevelFilterChange,
    onCreateVideo,
    onEditVideo,
    onDeleteVideo
}) => {
    const levels = ['Principiante', 'Intermedio', 'Avanzado'];

    // Filter videos based on search and level
    const filteredVideos = videos.filter((video: Video) => {
        const matchesSearch = video.title.toLowerCase().includes(searchQuery.toLowerCase());
        const matchesLevel = levelFilter === 'Todos' || video.level === levelFilter;
        return matchesSearch && matchesLevel;
    });

    return (
        <Section>
            <SectionHeader>
                <SectionTitle>
                    {React.createElement((Icons as any).FiVideo, { size: 24 })}
                    Gestión de Vídeos
                </SectionTitle>
                <AddButton onClick={onCreateVideo}>
                    {React.createElement((Icons as any).FiPlus, { size: 18 })}
                    Nuevo Vídeo
                </AddButton>
            </SectionHeader>

            <FiltersBar>
                <FilterSelect value={levelFilter} onChange={(e) => onLevelFilterChange(e.target.value)}>
                    <option value="Todos">Todos los niveles</option>
                    {levels.map(level => (
                        <option key={level} value={level}>{level}</option>
                    ))}
                </FilterSelect>
            </FiltersBar>

            {loading && (
                <LoadingState>
                    <SpinningLoader>
                        {React.createElement((Icons as any).FiLoader, { size: 24 })}
                    </SpinningLoader>
                    Cargando vídeos...
                </LoadingState>
            )}

            {error && <ErrorState>{error}</ErrorState>}

            {!loading && !error && (
                <DataTable>
                    <TableHeader>
                        <div>Título</div>
                        <div>Duración</div>
                        <div>Nivel</div>
                        <div>Acciones</div>
                    </TableHeader>
                    {filteredVideos.map((video: Video) => (
                        <TableRow key={video.id}>
                            <TableCell>{video.title}</TableCell>
                            <TableCell>{video.duration}</TableCell>
                            <TableCell>{video.level}</TableCell>
                            <TableCell>
                                <ActionButtons>
                                    <ActionBtn onClick={() => onEditVideo(video)}>
                                        {React.createElement((Icons as any).FiEdit, { size: 14 })}
                                    </ActionBtn>
                                    <ActionBtn $variant="delete" onClick={() => onDeleteVideo(video.id)}>
                                        {React.createElement((Icons as any).FiTrash2, { size: 14 })}
                                    </ActionBtn>
                                </ActionButtons>
                            </TableCell>
                        </TableRow>
                    ))}
                </DataTable>
            )}
        </Section>
    );
};

export default AdminVideos;
